import {hitGoogleTagManager} from "./hit_google_tag_manager";

type EventAction = "view" | "click" | "fill" | "submit";

export const hitGtmUserPhoneNumber = (action: EventAction) => {
    const gtmData = {
        event: "price_unlock_phone",
        event_action: action
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

type EventAction = "view" | "click" | "fill" | "submit";

export const hitGtmUserPhoneNumber = (action: EventAction) => {
    const gtmData = {
        event: "price_unlock_phone",
        event_action: action
    };

    hitGoogleTagManager(gtmData);
};
